import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { SiaTextBoxComponent } from '@sia/inputs';
import { SiaTranslatePipe } from '@sia/shared';

@Component({
  selector: 'sia-rename-dialog',
  templateUrl: './sia-rename-dialog.component.html',
  styleUrls: ['./sia-rename-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    SiaTextBoxComponent,
    FormsModule,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    SiaTranslatePipe,

    MatIcon,
  ],
})
export class SiaRenameDialogComponent implements AfterViewInit {
  dialogRef = inject<MatDialogRef<SiaRenameDialogComponent>>(MatDialogRef);
  @ViewChild(SiaTextBoxComponent, { read: ElementRef })
  textBoxComponent!: ElementRef;

  constructor() {
    const data = inject(MAT_DIALOG_DATA);
    const dialogRef = this.dialogRef;

    dialogRef.updateSize('min(400px, 90%)');
    this.fileName = data.fileName;
    this.title = data.title;
  }

  fileName: string = '';
  title: string = 'Rinomina elemento';

  ngAfterViewInit() {
    // Focus the text box after view initialization
    if (this.textBoxComponent) {
      setTimeout(() => {
        const input =
          this.textBoxComponent.nativeElement.querySelector('input, textarea');
        if (input) {
          input.focus();
        }
      });
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.dialogRef.close(this.fileName);
  }
}
